import { z } from 'zod';

export const TransformFailedDetails = z.object({
  status: z.literal('Failed'),
  errorMessage: z.string(),
});

export type TransformFailedDetails = z.infer<typeof TransformFailedDetails>;
